import { Component, OnInit, SimpleChanges, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { SignaturePadComponent } from '../../../commons/signature-pad/signature-pad.component';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from '../../../services/document.service';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { saveAs } from "file-saver";
import * as moment from 'moment';
@Component({
  selector: 'app-dna-checklist',
  templateUrl: './dna-checklist.component.html',
  styleUrls: ['./dna-checklist.component.scss']
})
export class DnaChecklistComponent implements OnInit {

  @Input('singleJob') job
  medicalDAChecklistForm
  singleJobDetails
  clientsList = []
  locationDetails
  locationList = []
  selectedClients = []
  medicalSign = false
  jobId
  medicalFormDetails
  isEdit = false
  loading;
  user: any;

  constructor(
    public dialog: MatDialog,
    public formBuilder: FormBuilder,
    public documentService: DocumentService,
    public _snackBar: MatSnackBar,
    private router: Router,
  ) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.createForm()
  }



  ngOnChanges(changes: SimpleChanges): void {

    if (changes.job && changes.job.currentValue) {
      this.singleJobDetails = changes.job.currentValue
      this.clientsList = this.singleJobDetails.clients
      console.log("what is the single job details", this.singleJobDetails);
      this.jobId = this.singleJobDetails._id
      this.getDAFormValue()
    }


  }

  // FORM GROUP



  createForm(details?) {


    this.medicalDAChecklistForm = new FormGroup({
      clients: new FormControl((details && details.clients) ? details.clients : ''),
      locations: new FormControl((details && details.locations) ? details.locations : ''),
      officers: new FormControl((details && details.officers) ? details.officers : ''),
      startDate: new FormControl((details && details.startDate) ?details.startDate : ''),
      toiletFacilities: new FormControl((details && details.toiletFacilities) ? details.toiletFacilities : ''),
      toiletFacilities1: new FormControl((details && details.toiletFacilities1) ? details.toiletFacilities1 : ''),
      toiletFacilities2: new FormControl((details && details.toiletFacilities2) ? details.toiletFacilities2 : ''),
      toiletFacilities3: new FormControl((details && details.toiletFacilities3) ? details.toiletFacilities3 : ''),
      comment: new FormControl((details && details.comment) ? details.comment : ''),
      toiletFacilities4: new FormControl((details && details.toiletFacilities4) ? details.toiletFacilities4 : ''),
      toiletFacilities5: new FormControl((details && details.toiletFacilities5) ? details.toiletFacilities5 : ''),
      toiletFacilities6: new FormControl((details && details.toiletFacilities6) ? details.toiletFacilities6 : ''),
      comment1: new FormControl((details && details.comment1) ? details.comment1 : ''),
      toiletFacilities7: new FormControl((details && details.toiletFacilities7) ? details.toiletFacilities7 : ''),
      toiletFacilities8: new FormControl((details && details.toiletFacilities8) ? details.toiletFacilities8 : ''),
      toiletFacilities9: new FormControl((details && details.toiletFacilities9) ? details.toiletFacilities9 : ''),
      toiletFacilities10: new FormControl((details && details.toiletFacilities10) ? details.toiletFacilities10 : ''),
      toiletFacilities11: new FormControl((details && details.toiletFacilities11) ? details.toiletFacilities11 : ''),
      toiletFacilities12: new FormControl((details && details.toiletFacilities12) ? details.toiletFacilities12 : ''),
      drug: new FormControl((details && details.drug) ? details.drug : ''),
      drug1: new FormControl((details && details.drug1) ? details.drug1 : ''),
      drug2: new FormControl((details && details.drug2) ? details.drug2 : ''),
      drug3: new FormControl((details && details.drug3) ? details.drug3 : ''),
      medicalName: new FormControl((details && details.medicalName) ? details.medicalName : ''),
      medicalDate: new FormControl((details && details.medicalDate) ? details.medicalDate : ''),
      medicalSign: new FormControl((details && details.medicalSign) ? details.medicalSign : ''),
      verifyName: new FormControl((details && details.verifyName) ? details.verifyName : ''),
    })
    if (this.user && this.user.isClient) {
      this.medicalDAChecklistForm.disable()
    }

  }



  // UTILITY



  selectClient(event) {
    console.log("event when client is selected", event);
    // let element = this.selectedClients.slice(-1)[0]
    // console.log("what is the last element of array", element);
    this.locationList = []
    this.selectedClients.forEach((item) => {
      this.locationList.push(item.location.title)
    })
    let location = this.locationList.reverse()
    console.log("location list", location);
    this.locationDetails = this.locationList.reverse().join(',')
    this.medicalDAChecklistForm.controls.locations.setValue(this.locationDetails);

  }


  addSignature() {
    this.openDialog(SignaturePadComponent).subscribe((data) => {
      console.log("data of sign", data);
      if (data == undefined) return

      let sign = data
      this.medicalSign = true
      this.medicalDAChecklistForm.patchValue({
        medicalSign: sign
      })
    })

  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  compareObjects(o1: any, o2: any): boolean {
    console.log("compareObjects called", o1._id, o2._id)
    return o1._id === o2._id;
  }


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'medicalDAChecklistForm')
      this.medicalDAChecklistForm.get(formControl).setValue(value);
  }


  downloadMedical() {
    this.loading = true
    console.log("down load medical checklist form", this.medicalFormDetails);

    this.documentService.checklistdowload(this.medicalFormDetails._id).

      subscribe((response) => {

        this.loading = false;
        this.handleSnackBar({ msg: "Download PDF Medical Checklist successfully!", button: "Ok" });
        console.log("download Sucessfully", response)
        let byteArray = new Uint8Array(response.data);

        console.log("======byteArray =======", byteArray)
        let blob = new Blob([byteArray], { type: 'application/pdf' });
        console.log("blobblobblobblobblob", blob)
        let location = []
        this.singleJobDetails.clients.forEach((item) => {
          location.push(item.location.title)
        })
        let title = 'Medical D&A Checklist' + location.join('-') + '' + moment(new Date).format("DD-MM-YYYY")
        saveAs(blob, title);
      },
        (err) => {
          this.loading = false;
          this.handleSnackBar({ msg: "Download PDF Failed", button: "Ok" });
          console.log("download pdf facing some issue", err);
        })
    // let finalArray = []
    // let details = this.medicalFormDetails.details.medicalDAChecklistForm
    // finalArray.push(['Platinum Rail Services D&A Checklist'], ['\r'], ['\r']);
    // finalArray.push(['Name of Client', 'Location', 'Officer(s)', 'Start Date'], ['\r']);
    // let clientArray = [];
    // let locationArray = [];
    // details.clients.forEach((item) => {
    //   clientArray.push(item.client.name)
    //   locationArray.push(item.location.title)
    // })
    // let clientDetails = clientArray.join('-');
    // let locationDetails = locationArray.join('-');
    // console.log("what is client details========", clientDetails);

    // finalArray.push([clientDetails, locationDetails, details.officers, moment(details.startDate).format("DD-MM-YYYY")], ['\r'], ['\r']);
    // finalArray.push(['Toilet Facilities:'], ['\r']);
    // finalArray.push(['Easy/close location to interview room used', details.toiletFacilities], ['\r']);
    // finalArray.push(['Private use', details.toiletFacilities1], ['\r']);
    // finalArray.push(['Multiple uses – checked each time of screening', details.toiletFacilities2], ['\r']);
    // finalArray.push(['WC with access and egress through one door only', details.toiletFacilities3], ['\r']);
    // finalArray.push(['Comments', details.comment], ['\r']);
    // finalArray.push(['Waiting area suitable', details.toiletFacilities4], ['\r']);
    // finalArray.push(['Handwashing facilities', details.toiletFacilities5], ['\r']);
    // finalArray.push(['Collection Officer has control of entry over testing facilities (if not re-prepare after each test)', details.toiletFacilities6], ['\r']);
    // finalArray.push(['Audiometer pre-use check complete?', details.noiseLevels3], ['\r']);
    // finalArray.push(['Comments', details.comment1], ['\r']);
    // finalArray.push(['Ground floor windows of toilet facilities – closed/sealed against opening', details.toiletFacilities7], ['\r']);
    // finalArray.push(['All water sources sealed and adulterating materials removed/isolated from toilet cubicle and blue dye added to the toilet/cistern', details.toiletFacilities8], ['\r']);
    // finalArray.push(['Blue Dye Tablets', details.toiletFacilities9], ['\r']);
    // finalArray.push(['Blue Loo', details.toiletFacilities10], ['\r']);
    // finalArray.push(['Liquid Blue Dye', details.toiletFacilities11], ['\r']);
    // finalArray.push(['Already in cistern', details.toiletFacilities12], ['\r'], ['\r']);
    // finalArray.push(['Drug Screening Kit Available'], ['\r']);
    // finalArray.push(['Drug Kits', details.drug], ['\r']);
    // finalArray.push(['Breathalyser/Printer', details.drug1], ['\r']);
    // finalArray.push(['Urine Dipstick', details.drug2], ['\r']);
    // finalArray.push(['Paperwork including COC forms & Drug Testing Collection Officer Report Form</mat-label>', details.drug3], ['\r']);
    // let singleLine = 'I certify ' + details.verifyName + ' that urine samples have been posted to Matrix Diagnostics Ltd by:'
    // finalArray.push([singleLine], ['\r']);
    // finalArray.push(['Name', details.medicalName], ['\r']);
    // finalArray.push(['Date', moment(details.medicalDate).format("DD-MM-YYYY")], ['\r']);









    // if (finalArray && finalArray.length) {

    //   let str = "";
    //   finalArray.forEach(row => {
    //     let line = "";
    //     let columns =
    //       typeof row !== "object" ? JSON.parse(row) : Object.values(row);
    //     columns.forEach(column => {
    //       if (line !== "") {
    //         line += ";";
    //       }
    //       if (typeof column === "object") {
    //         line += JSON.stringify(column);
    //       } else {
    //         line += column;
    //       }
    //     });
    //     str += line + "\r\n";
    //   });


    //   let blob = new Blob(finalArray, { type: 'text/csv;charset=utf-8;' });
    //   // let name = learnerName
    //   // let title = jobName ? jobName + "Register" : 'Register'
    //   saveAs(blob, this.singleJobDetails.title + ".csv");
    //     setTimeout(() => {
    //         this.loading = false
    //     this.handleSnackBar({ msg: "D&A Checklist Document Download successfully!", button: "Ok" });
    //   }, 300)
    // }

  }




  // API CALL





  getDAFormValue() {
    this.loading = true
    this.documentService.getDAChecklistFormValue(this.jobId).subscribe((response) => {
      console.log("resposne of medical checklist form", response);
      if (response && response.length) {
        this.medicalFormDetails = response[0]
        this.isEdit = true
        this.createForm(this.medicalFormDetails.details.medicalDAChecklistForm)
        this.loading = false
        if (this.medicalFormDetails.details.medicalDAChecklistForm && this.medicalFormDetails.details.medicalDAChecklistForm.medicalSign != '') {
          this.medicalSign = true
        }
      } else {
        this.loading = false
      }
    }, error => {
      console.log("error while get medical form details", error);

    })
  }






  submitMedicalForm() {
    console.log("final form value", this.medicalDAChecklistForm.value);
    this.loading = true
    if (this.isEdit == true) {
      let obj = {
        metaObj: {
          title: 'DAChecklist',
        },
        jobId: this.jobId,
        details: {},
        onModel: 'mpjob',
        documentMetaId: this.medicalFormDetails.documentMetaId._id,
        documentId: this.medicalFormDetails._id,
      }

      let details = {
        medicalDAChecklistForm: this.medicalDAChecklistForm.value
      }
      obj['details'] = details
      this.documentService.updateForm(obj).subscribe((response) => {
        console.log("response of iqa form", response);
        this.handleSnackBar({ msg: "D&A Checklist Document Update successfully!", button: "Ok" });
        this.loading = false
        this.router.navigate(['/mpjob/' + this.jobId], { queryParams: { currentTab: 3 } })
      }, error => {
        console.log("error while update form", error);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
      })
    } else {
      let obj = {
        metaObj: {
          title: 'DAChecklist',
        },
        jobId: this.jobId,
        details: {},
        onModel: 'mpjob'
      }

      let details = {
        medicalDAChecklistForm: this.medicalDAChecklistForm.value
      }
      obj['details'] = details
      this.documentService.addDocument(obj).subscribe((response) => {
        console.log("document resposne of iqa form", response);
        this.handleSnackBar({ msg: "D&A Checklist Document Created successfully!", button: "Ok" });
        this.router.navigate(['/mpjob/' + this.jobId], { queryParams: { currentTab: 3 } })
        this.loading = false
      }, error => {
        console.log("error while add iqa form", error);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
      })
    }
  }

}
